export const {
  REACT_APP_API_USER,
  REACT_APP_API_PASSWORD,
  REACT_APP_AWS_BUCKET_PATH,
  REACT_APP_RESTRICTED_AREA_URI,
} = process.env;

export const WEB_FAQ_CATEGORY = 1;
